export default "/_next/static/images/email_pattern-85b59533ccbe9d6583ba17667adb9a90.gif";